import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../api';

function Profile() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    whatsapp: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      const response = await auth.getProfile();
      setFormData({
        nom: response.data.nom,
        prenom: response.data.prenom,
        email: response.data.email,
        whatsapp: response.data.whatsapp || ''
      });
    } catch (err) {
      setError('Erreur lors du chargement du profil');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await auth.updateProfile({
        nom: formData.nom,
        prenom: formData.prenom,
        whatsapp: formData.whatsapp
      });
      
      // Mettre à jour le localStorage
      const user = JSON.parse(localStorage.getItem('user'));
      localStorage.setItem('user', JSON.stringify({ ...user, ...response.data }));
      
      setSuccess('Profil mis à jour avec succès !');
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la mise à jour');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="container" style={{ maxWidth: '600px', marginTop: '50px' }}>
      <div className="card">
        <h1 style={{ textAlign: 'center', color: '#667eea', marginBottom: '30px' }}>
          Mon Profil
        </h1>

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label>Prénom *</label>
              <input
                type="text"
                value={formData.prenom}
                onChange={(e) => setFormData({ ...formData, prenom: e.target.value })}
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={formData.email}
              disabled
              style={{ background: '#f0f0f0', cursor: 'not-allowed' }}
            />
            <small style={{ color: '#666' }}>L'email ne peut pas être modifié</small>
          </div>

          <div className="form-group">
            <label>WhatsApp</label>
            <input
              type="tel"
              value={formData.whatsapp}
              onChange={(e) => setFormData({ ...formData, whatsapp: e.target.value })}
              placeholder="+32 477 18 05 10"
              disabled={loading}
            />
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="submit" className="btn btn-primary" style={{ flex: 1 }} disabled={loading}>
              {loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
            <button type="button" onClick={() => navigate('/dashboard')} className="btn btn-secondary">
              Retour
            </button>
          </div>
        </form>

        <hr style={{ margin: '30px 0' }} />

        <button onClick={handleLogout} className="btn btn-danger" style={{ width: '100%' }}>
          🚪 Déconnexion
        </button>
      </div>
    </div>
  );
}

export default Profile;